/**
 * Global notification system.
 * Dispatches a custom event that App.js listens to for showing the global modal.
 * This avoids prop-drilling showAlert through every component.
 */

/**
 * Show a notification using the global modal.
 * @param {string} message - The message to display (supports basic HTML)
 * @param {'success'|'error'|'info'} type - Notification type
 */
export function showNotification(message, type = 'info') {
  window.dispatchEvent(
    new CustomEvent('global-notification', {
      detail: { message, type },
    })
  );
}

/**
 * Show a success notification
 */
export function notifySuccess(message) {
  showNotification(message, 'success');
}

/**
 * Show an error notification
 */
export function notifyError(message) {
  showNotification(message, 'error');
}

/**
 * Show an info notification
 */
export function notifyInfo(message) {
  showNotification(message, 'info');
}
